import { render, staticRenderFns } from "./CustomLAbelType5.vue?vue&type=template&id=15e28582&"
import script from "./CustomLAbelType5.vue?vue&type=script&lang=js&"
export * from "./CustomLAbelType5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports